var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"button is-outlined",class:_vm.color,attrs:{"data-id":"task-action","disabled":_vm.disabled},on:{"click":_vm.onClick}},[_vm._v(" "+_vm._s(_vm.action.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }